import { ApiService } from './api_service';

// Create a singleton instance of ApiService
// Using liveOrLocal = 0 for production API by default
// This can be configured based on environment variables if needed
export const apiService = new ApiService({
  liveOrLocal: import.meta.env.VITE_NEXT_PUBLIC_GMIND_BASEURL === 'false' ? 1 : 0,
  unauthorizedPage: '/auth'
});


export default apiService;
